export default {
  title: 'Istoricul editărilor meniului',
  subtitle: 'Vedeți cine a modificat prețurile, disponibilitatea și vizibilitatea pentru {{company}} — și când.',
  filters: {
    type: {
      label: 'Tip',
    },
    item: {
      placeholder: 'Toate elementele',
    },
    event: {
      label: 'Eveniment',
    },
  },
  columns: {
    when: 'Când',
    who: 'Modificat de',
    type: 'Tip',
    item: 'Element',
    event: 'Eveniment',
    changes: 'Modificări',
  },
  types: {
    product: 'Produs',
    modifier: 'Modificator',
  },
  events: {
    created: 'Creat',
    updated: 'Actualizat',
    deleted: 'Șters',
  },
  fields: {
    name: 'Nume',
    description: 'Descriere',
    price: 'Preț',
    is_available: 'Disponibilitate',
    is_visible: 'Vizibilitate',
    is_available_for_pickup: 'Disponibilitate ridicare',
    is_available_for_delivery: 'Disponibilitate livrare',
  },
  booleans: {
    on: 'Disponibil',
    off: 'Indisponibil',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Următor',
  },
  causers: {
    orders_terminal: 'Terminal comenzi',
  },
  system: 'Sistem',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Încărcarea istoricului editărilor meniului a eșuat',
  },
};
